<template>
    <div class="register-merchant">
        <div class="content">
            <h2 class="title">商户条约</h2>
            
            <div class="agreement-content">
                <p>1. 商户资格</p>
                <p>申请成为商户需要满足以下条件：</p>
                <p>- 年满18周岁</p>
                <p>- 具有完全民事行为能力</p>
                <p>- 遵守平台规则和相关法律法规</p>
                
                <p>2. 商户义务</p>
                <p>- 保证所提供信息的真实性和准确性</p>
                <p>- 遵守平台交易规则</p>
                <p>- 维护平台和用户的合法权益</p>
                
                <p>3. 平台权利</p>
                <p>- 对违规商户进行处罚</p>
                <p>- 修改和解释本协议的权利</p>
                
                <p>4. 免责声明</p>
                <p>- 平台不对商户的经营行为承担责任</p>
                <p>- 因不可抗力导致的损失，平台不承担责任</p>
            </div>
            
            <van-button 
                type="primary" 
                block 
                class="submit-btn"
                @click="onSubmit"
                v-if="!isMerchant"
            >
                成为商户
            </van-button>
            <van-button 
            v-else
                type="primary" 
                block 
                class="submit-btn"
                @click="onSubmit"
            >
                免费成为会员
            </van-button>
        </div>
    </div>
</template>

<script>
import { showDialog, showToast } from 'vant';
import request from '@/utils/request'
export default {
    name: 'RegisterMerchant',
    data() {
        return {
            joinFee:0,
            isMerchant:false
        }
    },
    created() {
        this.userInfo = this.$store.state.user.userInfo
        if (this.userInfo && Object.keys(this.userInfo).length > 0) {
        this.isMerchant = this.userInfo.isVip==1?false:true
        }
    },
    methods: {
        onSubmit() {
            request.get('/front/merchant/joinFee',{}).then(res=>{
        if(res.code == 200){
          this.joinFee = res.data.joinFee
          showDialog({
                title: '确认提示',
                message: `您需要每月支付${this.joinFee}￥,确定成为商家并已读遵守商家条约吗?`,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true,
                confirmButtonColor: '#1989fa'
            })
            .then(() => {
                    request.post('/front/merchant/vip/charge',{}).then(res=>{
                        if(res.code == 200){
                        console.log(res)
                        showToast('恭喜您，成为商户会员！')
                        this.$router.push('/profile')
                        }else{
                            showToast(res.msg)
                        }
                    })
            })
            .catch(() => {
            })
        }
      })
           
        }
    }
}
</script>

<style scoped>
.register-merchant {
    min-height: 100vh;
    background-color: #fff;
    padding: 20px;
}

.content {
    max-width: 600px;
    margin: 0 auto;
}

.title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #323233;
}

.agreement-content {
    padding: 16px;
    background-color: #f7f8fa;
    border-radius: 8px;
    margin-bottom: 24px;
    line-height: 1.6;
}

.agreement-content p {
    margin: 8px 0;
    color: #666;
}

.submit-btn {
    margin-top: 20px;
}
</style>